import { ResponseBase } from './../commonModels';
import { ListBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';
import { GarageSearchModel } from './garageSearch';
import * as InventoryModels from '../inventory/inventory';
import * as TyreOfferApiModels from '../tyre/tyreOfferApi';

export class GarageDictionaryListModel extends ResponseBase {
  Items: GaragePreviewModel[];
}

export class GarageListModel extends ListBaseModel {
  Items: GaragePreviewModel[];
}

export class GarageLocationListModel extends ListBaseModel {
  Items: GarageLocationModel[];
}

export class GarageObjectModel extends ResponseBase {
  Item: GarageModel;
}

export class ServicesModel {
  IsSteelRimStraightening: boolean;
  IsGlinRimStraightening: boolean;
  IsRftService: boolean;
  IsDoorToDoor: boolean;
  IsLightMechanic: boolean;
  IsFullMechanic: boolean;
  IsTpmsCalibration: boolean;
  IsAirConditionService: boolean;
}

export class CommonInformationModel {
  public IsActive: boolean;
  public IsTyreSendingBlocked: boolean;
  public ServiceCompanyTypeId: number;
  public ServiceCompanyType: string;
  public IsOnVacation: boolean;
  public IsSupplierOnly: boolean;
}

export class SettingsModel {
  public IsTyreSale: boolean;
  public IsTyreDispatch: boolean;
  public IsTruckService: boolean;
}

export class AppointmentPlacesModel {
  AppointmentOnlinePlacesCount: number;
  AppointmentOfflinePlacesCount: number;
}

export class GarageLocationModel {
  public GarageId: number;
  public Name: string;
  public Longitude: number;
  public Latitude: number;
  public City: string;
  public PostCode: string;
  public Street: string;
  public Telephone: string;
}

export class GaragePreviewModel {
  public GarageId: number;
  public Name: string;
  public NameAndNip: string;
  public IsSupplierOnly: boolean;
  public IsTyreSendingBlocked: boolean;
  public IsActive: boolean;
  public ServiceCompanyName: string;
  public ServiceCompanyId: number;
  public Mail: string;
  public Voivodeship: string;
  public City: string;
  public Street: string;
  public PostCode: string; 
  public Telephone: string;
  public ContactPerson: string;
  public OpeningHours: string;
  public OpeningHoursSaturday: string;
  public IsTyreSale: boolean;
  public IsTyreDispatch: boolean;
  public IsHoliday: boolean;

  public StartOfVacation: Date;
  public EndOfVacation: Date;

  // AdditionalServices contains 8 ises - it is only for display badges in column 'Usługi'
  public AdditionalServices: ServicesModel;
  // CommonInformation contains information related to badges  - it is only for display badges in column 'Nazwa'
  public CommonInformation: CommonInformationModel;
  // CommonInformation contains information related to badges  - it is only for display badges in column 'Ustawienia'
  public Settings: SettingsModel;

  // public AppointmentOnlinePlacesCount: number;
  // public AppointmentOfflinePlacesCount: number;
  public Appointments: AppointmentPlacesModel;

  public Longitude: number;
  public Latitude: number;

  public CustomerVisitDelayDays: number;

  public IsSelectedVirtual: boolean = false;

  public TyreSupplierGarages: TyreOfferApiModels.TyreSupplierGarageModel[];

  public IsCurierRegisterRequired: boolean;
  public CourierGarageOrderDelayDays: number;
}

export class GarageModel {
  public GarageId: number;
  public ServiceCompanyName: string;
  public ServiceCompanyType: string;
  public ServiceCompanyId: number;
  public Name: string;
  public Mail: string;
  public Voivodeship: string;
  public City: string;
  public PostCode: string;
  public Street: string;
  public Telephone: string;
  public ContactPerson: string;
  public OpeningHours: string;
  public OpeningHoursSaturday: string;
  public OpeningHoursSunday: string;
  public CountCarPlace: number;
  public CountTruckPlace: number;

  public IsDoingMechanics: boolean;
  public IsMechanicalOnly: boolean;

  public Mhprice: number;
  public CommissionForParts: number;
  public CommissionForAdditionalServices: number;

  public IsTyreOfferNotification: boolean;
  public IsSupplierOnly: boolean;
  public IsTyreOfferExecuteBlocked: boolean;
  public IsStartDiscountForTyreOfferBlocked: boolean;

  public CourierDeliveryDelayHours: number;
  public CourierGarageOrderDelayDays: number;
  public AddedByUserId: number;
  public AddedByUser: string;
  public AddDate: Date;
  public IsReadOnly: boolean;

  // Services badges
  public IsSteelRimStraightening: boolean;
  public IsGlinRimStraightening: boolean;
  public IsRftService: boolean;
  public IsDoorToDoor: boolean;
  public IsLightMechanic: boolean;
  public IsFullMechanic: boolean;
  public IsTpmsCalibration: boolean;
  public IsAirConditionService: boolean;
  // Settings badges
  public IsTyreSale: boolean;
  public IsTyreDispatch: boolean;
  public IsTruckService: boolean;
  // Common bades
  public IsActive: boolean;
  public IsTyreSendingBlocked: boolean;
  public ServiceCompanyTypeId: number;
  public IsOnVacation: boolean;

  public WarehouseAddress: string;
  public Nip: string;
  public StartOfVacation: Date;
  public EndOfVacation: Date;

  //  na potrzeby requestu { disable: false, field: '',  type: 'switch',  placeholder: 'Przypisać do wszystkich klientów'},
  public IsAllCustomers: boolean;

  // na potrzeby GUI, do uporzdkowania, bo to zmienna powiazana z polami STartOfVacation i  EndOfVaction
  public Vacation: DateRange;

  public Longitude: number;
  public Latitude: number;
  public SetPositionByAddress: boolean;

  public CustomerVisitDelayDays: number;

  // dane statystyczne o depozytach
  public DepositesTotal: number;
  public DepositesNonInventorized: number;
  public DepositesInventorized: number;
  public DepositesInventorizedConfirmed: number;
  public DepositesInventorizedChanged: number;
  public DepositesNew: number;

  public Inventories: InventoryModels.InventoryGarageModel[];

  public TyreSupplierGarages: TyreOfferApiModels.TyreSupplierGarageModel[];

  public IsGarageOrderAvailable: boolean;
  
  public TyrePurchaseLimitAmount: number;

  public IsCurierRegisterRequired: boolean;

  constructor() {
    this.GarageId = null;
    this.ServiceCompanyName = null;
    this.ServiceCompanyType = null;
    this.ServiceCompanyTypeId = null;
    this.ServiceCompanyId = null;
    this.Name = null;
    this.Mail = null;
    this.Voivodeship = null;
    this.City = null;
    this.PostCode = null;
    this.Street = null;
    this.Telephone = null;
    this.ContactPerson = null;
    this.OpeningHours = null;
    this.OpeningHoursSaturday = null;
    this.OpeningHoursSunday = null;
    this.CountCarPlace = null;
    this.CountTruckPlace = null;
    this.IsTyreSale = false;
    this.IsTruckService = false;
    this.IsTyreDispatch = false;
    this.IsDoingMechanics = false;
    this.IsMechanicalOnly = false;
    this.Mhprice = 0;
    this.CommissionForParts = 0;
    this.CommissionForAdditionalServices = 0;
    this.IsTyreOfferNotification = false;
    this.IsSupplierOnly = false;
    this.IsTyreSendingBlocked = false;
    this.CourierDeliveryDelayHours = null;
    this.CourierGarageOrderDelayDays = null;
    this.IsTyreOfferExecuteBlocked = false;
    this.IsStartDiscountForTyreOfferBlocked = false;
    this.IsActive = false;
    this.WarehouseAddress = null;

    // new fileds
    this.IsSteelRimStraightening = false;
    this.IsGlinRimStraightening = false;
    this.IsRftService = false;
    this.IsDoorToDoor = false;
    this.IsLightMechanic = false;
    this.IsFullMechanic = false;
    this.IsTpmsCalibration = false;
    this.IsAirConditionService = false;
    this.Nip = null;
    this.Vacation = new DateRange();
    this.StartOfVacation = null;
    this.EndOfVacation = null;
    this.IsOnVacation = false;
    this.Longitude = null;
    this.Latitude = null;
    this.SetPositionByAddress = false;
  }
}

export class GarageGroupEmailModel {
  Search: GarageSearchModel; // list o recipients
  Content: string;
}

export class GarageGroupMessageModel {
  Search: GarageSearchModel; // list o recipients
  Content: string;
  Valid: number;
}

export class GarageGroupMessagesListModel extends ListBaseModel {
  Items: GarageGroupMessageViewModel[];
}

export class GarageGroupMessageViewModel {
  GroupMessageId: number;
  GarageId: number;
  SentByUserId: number;
  Message: string;
  CreateDate: Date;
  UtilisationDate: Date;
  SentByUser: string;
}

export class GarageGroupMesageObjectModel extends ResponseBase {
  Item: GarageGroupMessageViewModel;
}

export class GarageDiscountPreviewModel {
  GarageDiscountId: number;
  SummerValue: number;
  WinterValue: number;
  GarageId: number;
  BrandId: number;
  ProducerId: number;
  BrandProducerId: number;
  BrandName: string;
  ProducerName: string;
  AllSeasonValue: number;
  IsExpanded: boolean = true;
}

export class GarageSetComissionModel {
  Search: GarageSearchModel;
  CommisionForParts: number;
  CommissionForAdditionalServices: number;
}

export class ProducerLocal {
  ProducerId: number;
  ProducerName: string;
  IsExpanded: boolean = true;
  SummerValue: number;
  WinterValue: number;
}

export class SetGarageDiscountPreviewModel {
  GarageId: number[];
  Discounts: GarageDiscountPreviewModel[];
}
